/**
 * UpcomingChallengeCard - Bright green card for upcoming challenges
 * Design: Screen 2 from home-screen-revamp
 *
 * Features:
 * - Bright green (#20f219) background
 * - "Starts in X days" badge (top-left)
 * - "Upcoming Challenge:" title + challenge name
 * - "Know More" CTA button
 * - Challenge image (right side, ~1/3 width)
 */

import { getChallengeImage, getTimeUntilStart } from "@/utils/challengeHelpers";

interface UpcomingChallengeCardProps {
  id: string;
  name: string;
  type: string;
  startDate: string;
  onClick: () => void;
}

export function UpcomingChallengeCard({
  name,
  type,
  startDate,
  onClick,
}: UpcomingChallengeCardProps) {
  const startsInText = getTimeUntilStart(startDate);
  const imageUrl = getChallengeImage(type);

  return (
    <div
      className="relative flex-shrink-0 w-full max-w-[346px] h-[130px] bg-[#20f219] rounded-[15px] overflow-hidden cursor-pointer transition-transform active:scale-[0.98]"
      onClick={onClick}
    >
      {/* Content - Left Side (2/3 width) */}
      <div className="relative z-10 flex flex-col h-full py-3 px-4 w-2/3">
        {/* Badge - "Starts in X days" */}
        <div className="inline-flex self-start items-center px-2 py-0.5 bg-black border border-[#056e2e] rounded-full mb-1.5">
          <span className="text-[7px] font-black text-[#20f219] tracking-tight uppercase">
            {startsInText}
          </span>
        </div>

        {/* Title */}
        <h3 className="text-[17px] font-semibold text-black leading-tight font-dm-sans whitespace-nowrap">
          Upcoming Challenge :
        </h3>

        {/* Challenge Name */}
        <p className="text-[13px] font-medium text-[#074d22] leading-tight font-dm-sans mt-0.5 line-clamp-1">
          {name}
        </p>

        {/* Know More Button */}
        <button
          className="inline-flex self-start items-center px-4 py-1.5 mt-auto bg-[#074820] border border-white/12 rounded-full"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          <span className="text-[11px] font-semibold text-[#20f219] tracking-tight font-dm-sans">
            Know More &gt;
          </span>
        </button>
      </div>

      {/* Image - Right Side (1/3 width, with left border matching panel bg) */}
      <div className="absolute right-0 top-0 w-1/3 h-full border-l-[5px] border-[#0e1713]">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover object-center"
        />
      </div>
    </div>
  );
}
